export default x => x.split('').reverse()[0];
